import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import Apiurl from "../../Helpers/apiUrl";
import { handleApiError } from "../../Helpers/handleApiError ";
import Swal from "sweetalert2";

const getToken = () => localStorage.getItem("u_token");

// Fetch draft

export const fetchLiveUser = createAsyncThunk(
  "fetchliveuser",
  async (_, { rejectWithValue }) => {
    try {
        const token = getToken();

      const response = await axios.get(`${Apiurl}live`, {
                headers: { Authorization: `Bearer ${token}` },
      });

      return response.data;
    } catch (error) {
      console.log("Live User Fetch Error:", error);
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch ." }
      );
    }
  }
);
export const fetchNotice = createAsyncThunk(
  "notice/fetchNotice",
  async (_, { rejectWithValue }) => {
 

    try {
      const response = await axios.get(`${Apiurl}notice`, {
       headers: { 'Content-Type': 'application/json' },
      });

      // if(!response.ok){

      // }

      return response.data;
    } catch (error) {
      console.log("Notice Fetch Error:", error);
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch ." }
      );
    }
  }
);
export const fetchNotification = createAsyncThunk(
  "notif/notification",
  async (draftId, { rejectWithValue }) => {
    const token = getToken();
    if (!token)
      return rejectWithValue({
        message: "No token found, authorization failed.",
      });

    try {
      const response = await axios.get(`${Apiurl}notification`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data;
    } catch (error) {
      console.log("Notification Fetch Error:", error);
      return rejectWithValue(
        error.response?.data || { message: "Failed to fetch ." }
      );
    }
  }
);

export const updateNotification = createAsyncThunk(
  "admin/updateNotification",
  async (dataa, { rejectWithValue }) => {
    try {
    const token = getToken();
      const response = await fetch(`${Apiurl}notification/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(dataa),
      });

      if (!response.ok) {
        const errorData = await response.json();

        return rejectWithValue(errorData);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue({
        message: "An error occurred while adding the stock.",
      });
    }
  }
);
export const updateNotice = createAsyncThunk(
  "admin/updateNotice",
  async (dataa, { rejectWithValue }) => {
    try {
    const token = getToken();
      const response = await fetch(`${Apiurl}notice/update`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
        body: JSON.stringify(dataa),
      });

      if (!response.ok) {
        const errorData = await response.json();

        return rejectWithValue(errorData);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      return rejectWithValue({
        message: "An error occurred while adding the stock.",
      });
    }
  }
);

export const closeNotif = () => (dispatch) => {
  dispatch(notifSlice.actions.popUp());
};

const initialState = {
  noticeMarquee: [],
  notification: null,
  error: null,
  showNotification: false,
  showMarquee:false,
  updateStatus:'idle',
  liveUser:[],
};

const notifSlice = createSlice({
  name: "notif",
  initialState,
  reducers: {
    popUp: (state) => {
      state.showNotification = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLiveUser.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchLiveUser.fulfilled, (state, action) => {
          state.liveUser = action.payload.data;
      })
      .addCase(fetchLiveUser.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchNotice.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchNotice.fulfilled, (state, action) => {
        if (action.payload.data[0]?.is_active == 1) {
          state.noticeMarquee = action.payload.data[0].content;
          state.showMarquee = true;
        }else{
          state.showMarquee = false;

        }
      })
      .addCase(fetchNotice.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(fetchNotification.pending, (state) => {
        state.error = null;
      })
      .addCase(fetchNotification.fulfilled, (state, action) => {
        if (action.payload.data[0]?.is_active == 1) {
          state.notification = action.payload.data[0].content;
          state.showNotification = true;
        }else{
          state.showNotification = false;

        }
      })
      .addCase(fetchNotification.rejected, (state, action) => {
        state.error = action.payload;
      })
      .addCase(updateNotice.pending, (state) => {
        state.error = null;
        state.updateStatus = 'pending';
      })
      .addCase(updateNotice.fulfilled, (state, action) => {
        state.noticeMarquee = action.payload.data;
        state.updateStatus = 'succeeded';
      })
      .addCase(updateNotice.rejected, (state, action) => {
        state.error = action.payload;
        state.updateStatus = 'failed';
      })
      .addCase(updateNotification.pending, (state) => {
        state.error = null;
        state.updateStatus = 'pending';
      })
      .addCase(updateNotification.fulfilled, (state, action) => {
        state.noticeMarquee = action.payload.data;
        state.updateStatus = 'succeeded';
      })
      .addCase(updateNotification.rejected, (state, action) => {
        state.error = action.payload;
        state.updateStatus = 'failed';
      })
  },
});

export default notifSlice.reducer;
